module.exports = __webpack_public_path__ + "static/img/38-2.5c5cf87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/38-2.jpg
// module id = hb6Y
// module chunks = 0